import React from 'react';
import s from './style.module.css';

export const TestLabel = () => {
    const isProduction = process.env.SENTRY_ENV === 'production';

    if (isProduction) return null;

    return (
        <div className={s.label_wrapper}>
            <span>検品</span>
        </div>
    );
};

export default TestLabel;
